import {
  GenerateQuestionsResponse,
  Question,
  QuestionType
} from 'services/campaign/types';
import { QuestionExpectedAnswer } from 'generated-graphql/types';
import { removeSubString } from 'utils/fomatting';

export const formatGeneratedQuestions = ({
  closedQuestions,
  openEndedQuestions
}: GenerateQuestionsResponse): Question[] => {
  const mappedClosedQuestions = closedQuestions.map<Question>((question) => ({
    content: removeSubString(question.content, 'Can you confirm that'),
    isMandatory: true,
    id: `question-${Math.random().toString(36).substring(7)}`,
    questionType: QuestionType.TEXT,
    expectedAnswer: QuestionExpectedAnswer.IsYes
  }));

  const mappedOpenEndedQuestions = openEndedQuestions.map<Question>(
    (question) => ({
      content: removeSubString(question.content, 'Can you confirm that'),
      hasPreferredAnswer: true,
      preferredAnswerText: question.preferredAnswer,
      isMandatory: false,
      id: `question-${Math.random().toString(36).substring(7)}`,
      questionType: QuestionType.TEXT
    })
  );

  return [...mappedClosedQuestions, ...mappedOpenEndedQuestions];
};
